<script setup>
import NavBar from "@/components/NavBar.vue";
import Footer from "@/components/Footer.vue";

import { onBeforeMount, onMounted } from "vue";

import StaticBar from "./components/StaticBar.vue";

import { overrideDefaultValidatorsMessage } from "@/services/validationSettings.js";

import { useCompanyStore} from "@/stores/companyStore.js";
const companyStore = useCompanyStore();

import { useAuthStore } from "@/stores/authStore.js";
const authService = useAuthStore();

import { useSocketStore } from "@/stores/socketConnectionStore";
const socketService = useSocketStore();

import { useLoadingStore } from "@/stores/loadingStore.js";
const loadingStore = useLoadingStore();

import { useRefreshStore } from '@/stores/refreshStore.js'
const refreshStore = useRefreshStore();

authService.checkCookies();

onBeforeMount(() =>{
  socketService.unauthConnect();
})

overrideDefaultValidatorsMessage();
</script>

<template>
  <div class="d-flex justify-content-center align-items-center bg-light">
    <div class="d-flex flex-column block-main">
      <div v-if="authService.isActiveUser">
        <nav-bar></nav-bar>
      </div>
      <transition name="fade" mode="out-in">
          <router-view class="router-main ps-5 pe-5" />
      </transition>
      <div v-if="authService.isActiveUser">
        <Footer></Footer>
      </div>  
    </div>
    <Teleport to="body">
      <div class="alerts-block position-fixed bottom-0 end-0">
        <static-bar
          v-if="loadingStore.loading"
          :message="`Выполняется запрос: ${loadingStore.loadingMessage}`"
          :header="'ЗАГРУЗКА'"
          :css-class="'bg-warning'"
          withLoading
          class="m-0"
        ></static-bar>
        <static-bar
          v-if="authService.isActiveUser && !socketService?.isConnected"
          :message="`Не удаётся подключиться к вебсокетам \nhost:' ${socketService?.host }`"
          :header="'ОШИБКА'"
          :css-class="'bg-danger'"
          class="m-0"
        ></static-bar>
				<static-bar v-for="[key, data] in socketService.success.entries()"
				:message="data.message"
				:header="data.header"
				:css-class="'bg-success'"
				class="m-0"
				></static-bar>
				<static-bar v-for="[key, data] in socketService.error.entries()"
					:message="data.message"
					:header="data.header"
					:css-class="'bg-danger'"
          :sentry="data.sentry"
					class="m-0"
				></static-bar>
				<static-bar v-for="[key, data] in socketService.pending.entries()"
					:message="data.message"
					:header="data.header"
					:css-class="'bg-warning'"
					withLoading
					class="m-0"
				></static-bar>
      </div>
    </Teleport>
  </div>
</template>

<style>
html {
  overflow-y: scroll;
}
.router-main {
  padding-bottom: 24px;
  padding-top: 24px;
  flex: 1 1 auto;
  padding-left: 56px;
  padding-right: 56px;
}
.block-main {
  min-width: 997px;
  min-height: 100vh;
  width: 100%;
  max-width: 1463px;
  position: relative;
  background-image: url("/bg_2.jpg");
  background-size: cover;
  background-attachment: fixed;
}

.alerts-block{
  z-index: 999;
  margin-bottom: 38px !important;
  margin-right: 78px !important;
}
.fade-enter-from, .fade-leave-to{
  opacity: 0;
}

.fade-enter-active, .fade-leave-active{
  transition: opacity 0.50s ease-out; 
}
</style>
